import { profileData } from "../data/profileData";

const Footer = () => (
	<footer className="footer">
		<p>© {new Date().getFullYear()} {profileData.name}</p>
	</footer>
);

export default Footer;
